import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { CancellableRequest, errorMessages } from '../model';

export const toCancellableRequest = <T>(observable: Observable<T>): CancellableRequest<T> => {
    let resolve: (value: T) => void;
    let reject: (reason?: any) => void;
    const cancellable = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    });

    // we need to define as let to be able to unsubscribe
    // because the subscription it's being called inside the response/error
    // to avoid uncaught ReferenceError
    let subscription: Subscription | undefined = undefined;
    subscription = observable.pipe(take(1)).subscribe(
        response => {
            subscription?.unsubscribe();
            resolve(response);
        },
        err => {
            subscription?.unsubscribe();
            reject(err);
        }
    );
    return {
        request: cancellable,
        cancel: () => {
            subscription.unsubscribe();
            reject(errorMessages.asyncOperationCancelled);
        }
    };
};
